import {
  collection,
  getDocs,
  query,
  Timestamp,
  where,
} from "firebase/firestore";
import { db } from "../config/firebaseConfig";
import { Candidate } from "../types/candidate";
import { BusinessData } from "../types/businessData";
import { ReviewStatus } from "../types/topLevelReciprocalMatch";

// Helper function to get the index of a value in an array and compare it with the index of another value in another array
/* function compareIndices(
  value1: any,
  value2: any,
  array1: string | any[],
  array2: string | any[]
) {
  return array1.indexOf(value1) === array2.indexOf(value2);
}

// Helper function to check if a user's age is within a range
function checkAge(userAge: number, ageRange: string) {
  const [minAge, maxAge] = ageRange.split("-").map(Number);
  return userAge >= minAge && userAge <= maxAge;
} */

export function formatNumberSwedishStyle(number: number) {
  return new Intl.NumberFormat("sv-SE").format(number);
}

export const adFilter = (
  userData: any,
  adData: any,
  businessUser?: any
  /*  typeOfMeny?: string */
) => {
  const businessOrgNumber = businessUser.orgNumber;

  const userCurrentOrgNumber = userData.prevOrgNumber;

  const sameCompany = businessOrgNumber === userCurrentOrgNumber;

  if (sameCompany && userData.hide) {
    return false;
  }

  // ---seeked role---
  // user data
  const seekedRoleUser = ["storeSeller", "inSeller", "outSeller"];
  const seekedRoleAd = ["Butikssäljare", "Innesäljare", "Utesäljare"];

  // ---type of work hours / employment---
  // user data
  const typeOfWorkUser = ["partTime", "fullTime", "internship", "hourly"];
  const typeOfWorkAd = ["Deltid", "Heltid", "Praktik", "Timanställning"];

  // ---type of experience ---
  // user data
  const experienceUser = [0, 1, 3, 5, 10];
  const experienceAd = ["0+ år", "1+ år", "3+ år", "5+ år", "10+ år"];

  // ---region ---
  // user data
  const regionUser = [
    "falun",
    "gavle",
    "gothenburg",
    "halmstad",
    "helsingborg",
    "jonkoping",
    "kalmar",
    "karlskrona",
    "karlstad",
    "linkoping",
    "lulea",
    "lund",
    "malmo",
    "norrkoping",
    "nykoping",
    "stockholm",
    "umea",
    "uppsala",
    "visby",
    "vasteras",
    "vaxjo",
    "orebro",
    "ostersund",
  ];
  const regionAd = [
    "falun",
    "Gävle",
    "Göteborg",
    "Halmstad",
    "Helsingborg",
    "Jönköping",
    "Kalmar",
    "Karlskrona",
    "Karlstad",
    "Linköping",
    "Luleå",
    "Lund",
    "Malmö",
    "Norrköping",
    "Nyköping",
    "Stockholm",
    "Umeå",
    "Uppsala",
    "Visby",
    "Västerås",
    "Växjö",
    "Örebro",
    "Östersund",
  ];

  // ---driversLicense ---
  // user data
  const driversLicenseUser = [true, false];
  const driversLicenseAd = ["Ja", "Nej"];

  // ---langSkills english ---
  // user data
  const langSkillEngUser = [1, 2, 3];
  const langSkillEngAd = ["Nybörjare", "Medelnivå", "Flytande"];

  // ---langSkills swedish ---
  // user data
  const langSkillSwedUser = [1, 2, 3];
  const langSkillSwedAd = ["Nybörjare", "Medelnivå", "Flytande"];

  // ---seeked role---
  const userRealValueRole = seekedRoleUser.indexOf(userData.soughtOccupation);
  let resultRole: boolean;

  // Check if the ad has the new 'typeOfRoles' property
  if (
    adData.generalMenuData != null &&
    Object.hasOwn(adData.generalMenuData, "typeOfRoles")
  ) {
    // New code for the case when 'typeOfRoles' is an object
    const adRealValueRoles = Object.keys(
      adData.generalMenuData.typeOfRoles
    ).filter((role) => adData.generalMenuData.typeOfRoles[role]);

    // Check if the user's sought occupation is in the ad's roles array
    resultRole = adRealValueRoles.some((adRealValueRole) => {
      return userRealValueRole === seekedRoleAd.indexOf(adRealValueRole);
    });
  } else {
    // Old code for the case when 'typeOfRole' is a single string
    const adRealValueRole = seekedRoleAd.indexOf(
      adData.generalMenuData.typeOfRole
    );
    resultRole = userRealValueRole === adRealValueRole;
  }

  // ---type of work hours / employment---
  const userTypeOfWorkArray = userData.hours
    .split(",")
    .map((item: string) => item.trim());
  const adTypeOfWork = adData.generalMenuData.formOfEmployment;
  let resultTypeOfWork: boolean;

  if (typeof adTypeOfWork === "string") {
    const adTypeOfWorkArray = adTypeOfWork
      .split(",")
      .map((item: string) => item.trim());
    resultTypeOfWork = userTypeOfWorkArray.some((userType: string) =>
      adTypeOfWorkArray.some(
        (adType: string) =>
          typeOfWorkAd.indexOf(adType) === typeOfWorkUser.indexOf(userType)
      )
    );
  } else {
    resultTypeOfWork = userTypeOfWorkArray.some(
      (userType: string) =>
        typeOfWorkAd.indexOf(adTypeOfWork) === typeOfWorkUser.indexOf(userType)
    );
  }

  // ---type of experience ---
  const userRealexperience = experienceUser.indexOf(
    userData.experienceInSearchedOccupation
  );
  const adRealexperience = experienceAd.indexOf(
    adData.generalMenuData.experience
  );
  const resultExperience = userRealexperience >= adRealexperience;

  // ---type of age  ---
  const currentYear = new Date().getFullYear();
  let userRealAge = 0;
  // Skip candidate if no birthday data
  if (
    !userData.birthday ||
    userData.birthday === undefined ||
    userData.birthday === null ||
    userData.birthday.length === 0
  ) {
    return false;
  }

  if (typeof userData.birthday === "string") {
    userRealAge = currentYear - parseInt(userData.birthday?.substring(0, 4));
  } else if (userData.birthday instanceof Timestamp) {
    userRealAge = currentYear - userData.birthday.toDate().getFullYear();
  }

  const transformedAdAgeData = Object.keys(
    adData.generalMenuData.prefAges
  ).reduce((o: any, key: any) => {
    adData.generalMenuData.prefAges[key] === true &&
      (o[key] = adData.generalMenuData.prefAges[key]);

    return o;
  }, {});

  const transformedAdAgeDat2 = Object.keys(transformedAdAgeData);

  const transformedAdAgeData3 = transformedAdAgeDat2.map((str: any) => {
    try {
      const strArray = str
        .substring(0, str.length - 3)
        .replace("+", "")
        .split("-");

      return strArray.map(Number);
    } catch (e) {
      console.error(e);
      console.error("ERROR_STRING", str);
    }
  });

  const resultAgeArrayOfBooleans = [] as any;

  transformedAdAgeData3.forEach((element) => {
    if (element.length === 1) {
      resultAgeArrayOfBooleans.push(element < userRealAge);
    } else {
      resultAgeArrayOfBooleans.push(
        userRealAge >= element[0] && userRealAge <= element[1]
      );
    }
  });

  const resultAge = resultAgeArrayOfBooleans.includes(true);

  // ---type of remote---
  const resultRemote =
    userData.remote && Boolean(adData.generalMenuData?.region?.remote);

  // ---type of region ---
  const userCities = userData.city
    .split(",")
    .map((city: string) => city.trim().toLowerCase());
  const adRegion = adData.generalMenuData?.region?.regionInner ?? "";
  let resultRegion: boolean;

  // Check if adRegion is a comma-separated string of multiple regions
  if (typeof adRegion === "string" && adRegion.includes(",")) {
    const adRegionArray = adRegion
      .split(",")
      .map((item) => item.trim().toLowerCase());
    resultRegion = resultRemote
      ? true
      : userCities.some((userCity: string) => adRegionArray.includes(userCity));
  } else {
    // Single region mode - use mapping
    const adRealRegion = regionAd.indexOf(adRegion);
    resultRegion = resultRemote
      ? true
      : userCities.some((userCity: string) => {
          const userCityIndex = regionUser.indexOf(userCity);
          return userCityIndex === adRealRegion;
        });
  }

  // ---type of drivers license ---
  const userRealdriversLicense = driversLicenseUser.indexOf(
    userData.driversLicense
  );
  const adRealdriversLicense = driversLicenseAd.indexOf(
    adData.generalMenuData.driversLicense
  );
  const resultDriversLicense =
    adData.generalMenuData.driversLicense === "Nej"
      ? true
      : userRealdriversLicense === adRealdriversLicense;

  // ---langSkills eng ---
  const userRealLangSkillEng = langSkillEngUser.indexOf(userData.engLangSkill);
  const adRealLangSkillEng = langSkillEngAd.indexOf(
    adData.languageSkillsMenuData.english
  );
  const resultLangSkillEng = userRealLangSkillEng >= adRealLangSkillEng;

  // ---langSkills swed---
  const userRealLangSkillSwe = langSkillSwedUser.indexOf(
    userData.swedLangSkill
  );
  const adRealLangSkillSwe = langSkillSwedAd.indexOf(
    adData.languageSkillsMenuData.swedish
  );
  const resultLangSkillSwe = userRealLangSkillSwe >= adRealLangSkillSwe;

  // --- Filter salary mode ---
  const salaryMode = adData.aboutTheAdData.salaryMode;
  const salaryExpectionUser = userData.salary;
  const salaryExpectationAd = adData.aboutTheAdData.salaryExpectation;
  const salaryResult =
    // Dealbreaker
    salaryMode === "dealbreaker"
      ? salaryExpectationAd >= salaryExpectionUser
      : // Flex adds 15% to the salary expectation
      salaryMode === "flex"
      ? salaryExpectationAd * 1.15 >= salaryExpectionUser
      : // Else return true for all other cases
        true;

  const finalArrayCheckIfAllTrue = [
    resultRole,
    resultTypeOfWork,
    resultExperience,
    resultAge,
    resultRegion,
    resultDriversLicense,
    resultLangSkillEng,
    resultLangSkillSwe,
    salaryResult,
  ];

  const result = finalArrayCheckIfAllTrue.every((val) => val === true);

  return result;
};

export function isEmpty(val: string) {
  return val === undefined || val == null || val.length <= 0;
}

export function isValidOrgNummer(input: string) {
  // Remove any hyphens or spaces in the input
  input = input.replace(/[- ]/g, "");

  // Ensure input is 10 characters long
  if (input.length !== 10) {
    return false;
  }

  // Check that the third digit is at least a 2
  if (parseInt(input.charAt(2), 10) < 2) {
    return false;
  }

  // Calculate the control digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let digit = parseInt(input.charAt(i), 10);
    if (i % 2 === 0) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
  }
  const controlDigit = (10 - (sum % 10)) % 10;

  // Verify that the control digit matches
  const inputControlDigit = parseInt(input.charAt(9), 10);
  return controlDigit === inputControlDigit;
}


export const getCurrentlySelectedAdSpecificCollection = async (
  selectedAd: string,
  collectionName: string
): Promise<any[] | undefined> => {
  try {
    const subColRef = collection(db, "JobAds", selectedAd, collectionName);

    const qSnap = await getDocs(subColRef);

    return qSnap.docs.map((d) => d.data().uid);
  } catch (e) {
    console.error(e);
  }
};

export const getReciprocalMatchCandidateIds = async (selectedAd: string) => {
  const q = query(
    collection(db, "TopLevelReciprocalMatches"),
    where("jobAdId", "==", selectedAd)
  );

  const querySnapshot = await getDocs(q);

  // Filter documents where status is "open" or status is undefined
  const filteredDocs = querySnapshot.docs.filter((d) => {
    const data = d.data();

    return !data.status || data.status === "open";
  });

  // Map the filtered documents to their candidateId
  return filteredDocs.map((d) => {
    const data = d.data();
    return {
      matchId: d.id,
      candidateId: data.candidateId as string,
      reviewStatus: data.reviewStatus as ReviewStatus | undefined,
    };
  });
};

export const roleMap = {
  inSeller: "Innesäljare",
  outSeller: "Utesäljare",
  storeSeller: "Butikssäljare",
};

export const obfuscateUserData = (data: Candidate) => {
  const obfuscateString = (str: string) => str.replace(/./g, "*");
  const obfuscateNumber = (num: number) => num.toString().replace(/./g, "*");

  const obfuscatedData: Candidate = { ...data };

  const result = obfuscatedData as Record<keyof Candidate, Candidate[keyof Candidate]>;
  for (const key of Object.keys(data) as (keyof Candidate)[]) {
    const value = data[key];
    if (typeof value === "string") {
      result[key] = obfuscateString(value) as Candidate[keyof Candidate];
    } else if (typeof value === "number") {
      result[key] = obfuscateNumber(value) as Candidate[keyof Candidate];
    }
  }
  return result;
};

export function calculateMatchScore(adTags: string[], candidateTags: string[]) {
  // Count how many ad tags are present in the candidate's tags
  const matchingTagsCount = adTags.filter((tag) =>
    candidateTags.includes(tag)
  ).length;

  // Calculate the score as a percentage
  const score = (matchingTagsCount / adTags.length) * 100;

  // Round score to zero decimals before returning
  return Math.round(score);
}

/**
 * Get the ad limit for a business with fallback to accountType-based limits
 * @param businessProfile - The business profile data
 * @returns The number of ads the business can create
 */
export function getBusinessAdLimit(
  businessProfile: BusinessData | null | undefined
): number {
  // If no business profile, return 0
  if (!businessProfile) {
    return 0;
  }

  // If adLimit is explicitly set, use it
  if (
    businessProfile.adLimit !== undefined &&
    businessProfile.adLimit !== null
  ) {
    return businessProfile.adLimit;
  }

  // Fallback to accountType-based limits
  switch (businessProfile.accountType) {
    case "unlimited":
      return Infinity; // Unlimited ads
    case "premium":
      return 1; // Premium accounts can have 1 active ad
    case "pro":
      return 1; // Pro accounts can have 1 active ad
    case "disabled":
      return 0; // Disabled accounts can't create ads
    default:
      return 0; // Default to 0 for unknown account types
  }
}

/**
 * Check if a business can create more ads
 * @param businessProfile - The business profile data
 * @param currentAdCount - The current number of active ads
 * @returns True if the business can create more ads
 */
export function canBusinessCreateMoreAds(
  businessProfile: BusinessData | null | undefined,
  currentAdCount: number
): boolean {
  const adLimit = getBusinessAdLimit(businessProfile);
  return currentAdCount < adLimit;
}
